export function raceWithTimeout<T>(
  callback: (signal: AbortSignal) => Promise<T>,
  timeoutMs: number,
  errorMessage = "Timeout exceeded"
): Promise<T> {
  const controller = new AbortController();
  const { signal } = controller;

  const timeoutPromise = new Promise<never>((_resolve, reject) => {
    const timeout = setTimeout(() => {
      controller.abort("timeout");

      reject(new Error(errorMessage));
    }, timeoutMs);

    signal.addEventListener("abort", () => {
      clearTimeout(timeout);
    });
  });

  const callbackPromise = callback(signal).catch((error) => {
    if (signal.aborted && signal.reason === "timeout") {
      throw new Error(errorMessage);
    }
    throw error;
  });

  return Promise.race([callbackPromise, timeoutPromise]);
}
